// extracted by mini-css-extract-plugin
export default {"tab_container":"styles_tab_container__RSWiF","tab_item":"styles_tab_item__B3EvK","active":"styles_active__Y3jBk"};